import React from 'react'

export default function Blog() {
  return (
    <p className="lead m-4">You can visit our blog at <a href="https://blog.test7777.ml">blog.test7777.ml</a></p>
  );
}
